import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { loadStripe } from '@stripe/stripe-js'
import { Spinner } from 'lp-components'
import { StripeContext } from 'contexts'
import {
  REACT_APP_STRIPE_PUBLISHABLE_KEY,
  SEATOW_PHONE,
  SEATOW_PHONE_DIGITS,
} from 'config'

const propTypes = {
  children: PropTypes.node.isRequired,
}

function StripeProvider({ children }) {
  const [stripePromise] = useState(() =>
    loadStripe(REACT_APP_STRIPE_PUBLISHABLE_KEY),
  )
  const [isReady, setIsReady] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const initStripe = async () => {
      try {
        await stripePromise
        setIsReady(true)
      } catch (err) {
        setError(err)
      }
    }
    initStripe()
  }, [stripePromise])

  if (error) {
    return (
      <>
        <p>
          Oops! Something went wrong. Try disabling ad or privacy blockers for
          this site, or check your connection and try again.
        </p>
        <p>
          If you continue to see this error, please contact Sea Tow for
          assistance at <a href={`tel:${SEATOW_PHONE}`}>{SEATOW_PHONE}</a> (
          {SEATOW_PHONE_DIGITS}).
        </p>
      </>
    )
  }

  if (!isReady) return <Spinner />

  return (
    <StripeContext.Provider value={stripePromise}>
      {children}
    </StripeContext.Provider>
  )
}

StripeProvider.propTypes = exact(propTypes)

export default StripeProvider
